// src/services/signalr.js
import * as signalR from "@microsoft/signalr";

let connection = null;
const callbacks = {};

const signalrService = {
  connect(authKey, driverServiceNo) {
    if (connection?.state === signalR.HubConnectionState.Connected) return;

    connection = new signalR.HubConnectionBuilder()
      // .withUrl("https://aeroviewbackend.dockyardsoftware.com/hubs/driver", {
        .withUrl("https://aeroviewbackend.dockyardsoftware.com/hubs/driver", {
        accessTokenFactory: () => authKey,
      })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();

    connection.on("BookingNew", (booking) => {
      console.log("NEW BOOKING VIA SIGNALR:", booking);
      if (callbacks.onNewBooking) callbacks.onNewBooking(booking);
    });

    connection.start()
      .then(() => {
        console.log("SignalR Connected");
        connection.invoke("JoinDriverGroup", driverServiceNo);
      })
      .catch(err => console.error("SignalR Error:", err));
  },

  onNewBooking(callback) {
    callbacks.onNewBooking = callback;
  },

  disconnect() {
    if (connection) connection.stop();
    callbacks.onNewBooking = null; // Clear callback to prevent leaks
  }
};

export default signalrService;